import { useToast } from "./use-toast"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "./toast"
import { CheckCircle, XCircle, AlertCircle, Info } from "lucide-react"
import { cn } from "../../lib/utils"

const getToastIcon = (variant: string | null | undefined) => {
  if (!variant) return <Info className="h-5 w-5 text-blue-500" />
    
  switch (variant) {
    case 'success':
      return <CheckCircle className="h-5 w-5 text-green-500" />
    case 'destructive':
      return <XCircle className="h-5 w-5 text-red-500" />
    case 'warning':
      return <AlertCircle className="h-5 w-5 text-yellow-500" />
    case 'info':
      return <Info className="h-5 w-5 text-blue-500" />
    default:
      return <Info className="h-5 w-5 text-blue-500" />
  }
};

export function Toaster() {
  const { toasts } = useToast()

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, variant, ...props }) {
        return (
          <Toast key={id} variant={variant} {...props}>
            <div className="flex items-start space-x-3">
              <div className="flex-shrink-0 mt-0.5">
                {getToastIcon(variant)}
              </div>
              <div className="flex-1 grid gap-1">
                {title && (
                  <ToastTitle className="font-semibold">
                    {title}
                  </ToastTitle>
                )}
                {description && (
                  <ToastDescription className="text-sm opacity-90">
                    {description}
                  </ToastDescription>
                )}
              </div>
            </div>
            {action}
            <ToastClose className="hover:scale-110 active:scale-95 transition-transform duration-200" />
          </Toast>
        )
      })}
      <ToastViewport />
    </ToastProvider>
  )
}
